<p-table [showGridlines]="true"
  [value]="searchResult?.Result"
  [rows]="searchParams ? searchParams.PageSize : 20"
  [totalRecords]="searchResult?.TotalCount"
  (onLazyLoad)="lazyLoad($event)"
  [lazyLoadOnInit]="false"
  [lazy]="true"
  [loading]="loading"
>
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="ProfileName" style="min-width: 400px">
        {{ 'communications.mass-comm-message-admin.analytics.top-five-members-grid.profile-name' | translate | ucfirst }}
        <p-sortIcon field="ProfileName"></p-sortIcon>
      </th>
      <th pSortableColumn="EmailOpens">
        {{ 'communications.mass-comm-message-admin.analytics.top-five-members-grid.email-opens' | translate | ucfirst }}
        <p-sortIcon field="EmailOpens"></p-sortIcon>
      </th>
      <th pSortableColumn="LinkClicks">
        {{ 'communications.mass-comm-message-admin.analytics.top-five-members-grid.link-clicks' | translate | ucfirst }}
        <p-sortIcon field="LinkClicks"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-profile>
    <tr>
      <td>
        <a (click)="navigateToProfile(profile.ProfileId)"> {{ profile.ProfileName }}</a>
      </td>
      <td>
        {{ profile.EmailOpens }}
      </td>
      <td>
        {{ profile.LinkClicks }}
      </td>
    </tr>
  </ng-template>
</p-table>
